import { RENDER_NEWSLETTER } from 'Component/Footer/Footer.config';

export * from 'SourceComponent/Footer/Footer.config.js';

export const NEWSLETTER_COLUMN = {
    title: __('Subscribe to Newsletter'),
    columnActiveKey: 'newsletterActive',
    subtitle: __(
        'Subscribe to our newsletter to receive the latest information about our new products and promotions.'
    ),
    items: [
        {
            render: RENDER_NEWSLETTER,
        },
    ],
};

export const FACEBOOK = 'https://www.facebook.com/mirat.eu/';
export const TWITTER = 'https://twitter.com/Miratpl';
export const PINTEREST = 'https://pl.pinterest.com/mirateu';
export const INSTAGRAM = 'https://www.instagram.com/mirateu/';
